<template >
  <div class="examtypeDialog">
    <el-dialog :title="title" :visible.sync="examtypeDialogVisible" width="500px" :close-on-click-modal="false">
      <el-form ref="examtypeForm" :model="examtypeForm"  label-width="140px" :rules="rules">
        <el-form-item label="试题类型"  class="is-required" prop="name" >
          <el-input v-model.trim="examtypeForm.name" maxlength="32" placeholder="请输入试题类型"> </el-input>
        </el-form-item>
        <el-form-item label="排序值"  class="is-required" prop="ordinal" >
          <el-input v-model.trim="examtypeForm.ordinal" placeholder="请输入试题类型排序值..." maxlength="9"></el-input>
        </el-form-item>
        <el-form-item label="是否选择题"  class="is-required"  >
          <!-- <el-radio-group v-model="examtypeForm.isSelectType">
            <el-radio label="0">否</el-radio>
            <el-radio label="1">是</el-radio>
          </el-radio-group> -->
          <el-switch
            v-model="examtypeForm.isSelectType"
            active-text="是"
            inactive-text="否">
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="examtypeDialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="save()" v-loading="loading">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/babel">
import examtypeService from '@/service/examtypeService'
// import commonService from '@/service/commonService'
export default {
  name: 'examtype',
  props: {
    id: {
      type: Number
    },
    subjectId: Number,
    rowData: Object,
    value: {
      type: Boolean,
      default () {
        return false
      }
    }
  },

  data () {
    return {
      title: '新增试题类型',
      loading: false,
      stages: [],
      subjects: [],
      examtypeForm: {
        name: '',
        isSelectType: false,
        subjectId: '',
        ordinal: '',
        id: ''
      },
      rules: {
        name: [
          {required: true, message: '请输入试题类型', trigger: ['blur', 'change']}
        ],
        ordinal: [
          {required: true, message: '请输入序列号', trigger: 'blur'},
          {pattern: /^[0-9]*$/, message: '请输入数字', trigger: ['blur', 'change']}
        ]
      }
    }
  },
  async mounted () {
  },

  methods: {
    save () {
      this.loading = true
      this.$refs.examtypeForm.validate(async valid => {
        if (valid) {
          try {
            await examtypeService.save(this.examtypeForm)
            // 重置表单
            this.$refs.examtypeForm.resetFields()
            this.$emit('success')
            this.loading = false
            this.examtypeDialogVisible = false
          } catch (e) {
            this.loading = false
            this.$message.error(e && e.msg)
          }
        }
        this.loading = false
      })
    }
  },
  watch: {
    examtypeDialogVisible (newVal, oldVal) {
      if (newVal) {
        if (this.$refs.examtypeForm) {
          // this.$refs.examtypeForm.resetFields()
          this.examtypeForm.name = ''
          this.examtypeForm.ordinal = ''
          this.examtypeForm.isSelectType = ''
          this.examtypeForm.subjectId = ''
        }
        // 加载初始化数据
        if (this.$props.id) {
          this.title = '编辑试题类型'
          // console.log(this.$props.rowData)
          // this.examtypeForm = this.$props.rowData
          this.examtypeForm.id = this.$props.rowData && this.$props.rowData.id
          this.examtypeForm.name = this.$props.rowData && this.$props.rowData.name
          this.examtypeForm.ordinal = this.$props.rowData && this.$props.rowData.ordinal
          this.examtypeForm.isSelectType = this.$props.rowData && this.$props.rowData.isSelectType
          this.examtypeForm.subjectId = this.$props.subjectId
        } else {
          this.examtypeForm.id = ''
          this.examtypeForm.name = ''
          this.examtypeForm.isSelectType = false
          this.examtypeForm.ordinal = ''
          this.title = '新增试题类型'
          this.examtypeForm.subjectId = this.$props.subjectId
        }
      }
    }
  },
  computed: {
    examtypeDialogVisible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
<style scoped>
.examtypeDialog .el-form-item .el-input{
  width:75%;
}
</style>
<style type="text/css">

</style>



// WEBPACK FOOTER //
// src/pages/layout/examtype-manage/edit-dialog/index.vue